module.exports = __webpack_public_path__ + "static/media/tradicional-2.8e4f4a24.png";